import { Component } from '@angular/core';

@Component({
    selector: 'pkp-info',
    template: require('./info.component.html'),
    preserveWhitespaces: true
})
export class InfoComponent {}
